import { render, staticRenderFns } from "./DiagnosticSection.vue?vue&type=template&id=289dd366&scoped=true&"
import script from "./DiagnosticSection.vue?vue&type=script&lang=js&"
export * from "./DiagnosticSection.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticSection.vue?vue&type=style&index=0&id=289dd366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289dd366",
  null
  
)

export default component.exports